'use strict';

var $ = require('jquery');
require('slick-carousel');

var SELECTORS = {
    PRODUCTIONGALLERY: '.js-production-gallery'
};

function init() {
    $(SELECTORS.PRODUCTIONGALLERY).slick({
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        cssEase: 'linear',
        speed: 600,
        fade: true,
        adaptiveHeight: false,
        autoplay: true,
        autoplaySpeed: 4000,
        arrows: false,
        dots: true
    });
}

module.exports = {
    init: init
};